import Room from "./booking/room";
import Insurance from "./booking/insurance";
import Activity from "./booking/activity";
import UserDiscount from "./booking/userDiscount";

var Booking = function () {

    "use strict";
    var self = this;

    this.startDate;
    this.endDate;
    this.adults;
    this.children;
    this.childrenAges = new Array();
    this.onlyAdults;
    this.discounts;
    this.rooms = new Array();
    this.insurances = new Array();
    this.activities = new Array();
    this.userDiscounts = new Array();
    this.paymentMethod;
    this.partialPayment;
};


Booking.prototype.setStartDate = function (startDate) {
    this.startDate = new Date(startDate);
};

Booking.prototype.setEndDate = function (endDate) {
    this.endDate = new Date(endDate);
};

Booking.prototype.setAdults = function (adults) {
    this.adults = adults;
};

Booking.prototype.setChildren = function (children) {
    this.children = children;
};

Booking.prototype.setChildrenAges = function (childrenAge) {
    this.childrenAges.push(childrenAge);
};

Booking.prototype.setOnlyAdults = function (onlyAdults) {
    this.onlyAdults = onlyAdults;
};

Booking.prototype.setDiscounts = function (discounts) {
    this.discounts = discounts;
};

Booking.prototype.addRoom = function (room) {
    var bookingRoom = new Room();
    let xRooms = room.x_vegades ? room.x_vegades : 1;
    bookingRoom.setName(xRooms + " x " + room.nombre);
    bookingRoom.setPeople(room.people_combination.linear_people_comb);
    bookingRoom.setPrice(room.price);
    bookingRoom.setRoom(xRooms);
    this.rooms.push(bookingRoom);
};

Booking.prototype.addInsurance = function (insurance, people) {
    var bookingInsurance = new Insurance();
    bookingInsurance.setId(insurance.id);
    bookingInsurance.setName(insurance.nombre);
    bookingInsurance.setPeople(people);
    bookingInsurance.setPrice(parseInt(insurance.precio));
    this.insurances.push(bookingInsurance);
};

Booking.prototype.addActivity = function (activity, people) {
    var bookingActivity = new Activity();
    bookingActivity.setId(activity.id);
    bookingActivity.setName(activity.nombre);
    bookingActivity.setPeople(people);
    bookingActivity.setPrice(activity.precio);
    bookingActivity.setSingleUnit(activity.venta_unidad);
    this.activities.push(bookingActivity);
};

Booking.prototype.addUserDiscount = function (userDiscount) {
    var bookingUserDiscount = new UserDiscount();
    bookingUserDiscount.setName(userDiscount.nombre);
    bookingUserDiscount.setPrice(userDiscount.precio);
    bookingUserDiscount.setInputName(userDiscount.name);
    this.userDiscounts.push(bookingUserDiscount);
};

Booking.prototype.getTotalPrice = function () {
    var price = 0;
    $.each(this.rooms, function (index, room) {
        price += room.price;
    });
    $.each(this.activities, function (index, activity) {
        price += parseInt(activity.price * activity.people);
    });
    $.each(this.insurances, function (index, insurance) {
        price += parseInt(insurance.price * insurance.people);
    });
    $.each(this.userDiscounts, function (index, discount) {
        price -= parseInt(discount.price);
    });
    if (price < 0) {
        price = 0;
    }
    return price;
};

Booking.prototype.setPaymentMethod = function (paymentMethod) {
    this.paymentMethod = paymentMethod;
};

Booking.prototype.setPartialPayment = function (partialPayment) {
    this.partialPayment = partialPayment;
};

Booking.prototype.hasChildrenWithAgeOrLess = function (ageLimit) {
    if (this.children <= 0) {
        return false;
    }

    var exists = false;

    $.each(this.childrenAges, function (index, age) {
        if (age !== "" && age <= ageLimit) {
            exists = true;
            return false;
        }
    });

    return exists;
}

export default Booking;
